<template>
  <div>
  <b-container>
    <b-row>
      <div class="w-100 text-center mt-3">
        <h3>ORDER PARTS</h3>
      </div>
    </b-row>

    <b-row class="mt-3">
      <b-col sm="4" class="mt-3">
        <b-form-input size="lg" class="pretraga text-uppercase" v-model="code"
                      type="text"
                      v-on:keyup.enter="search"
                      :placeholder="`ENTER ${inputType} TO SEARCH FOR`">
        </b-form-input>
      </b-col>
      <b-col sm="3" class="mt-3">
        <b-input-group>
          <b-form-input size="lg" v-model="metaData" type="text" placeholder="ORDER FOR"></b-form-input>
          <b-input-group-append>
            <b-button @click="toggleIo" variant="primary">
              <b-icon-wrench v-if="io"></b-icon-wrench>
              <b-icon-people v-else></b-icon-people>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col sm="3" class="mt-4">
        <b-form-group v-slot="{ ariaDescribedby }" class="d-inline">
          <b-form-radio-group
            id="radio-group-2"
            v-model="inputType"
            :aria-describedby="ariaDescribedby"
            name="radio-sub-component"
          >
            <b-form-radio :aria-describedby="ariaDescribedby" name="oem" value="oem">OEM</b-form-radio>
            <b-form-radio :aria-describedby="ariaDescribedby" name="sku" value="sku">SKU</b-form-radio>
            <b-form-radio :aria-describedby="ariaDescribedby" name="ean" value="ean">EAN</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="2" class="mt-3">
        <b-button @click="search" block size="lg">Search</b-button>
      </b-col>
    </b-row>
  </b-container>

  <b-container class="mt-3">
    <b-row v-if="loading">
      <div class="w-100 text-center">
        <b-icon icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </b-row>
    <b-row v-else-if="articles.length">
      <b-table striped :items="articles" :fields="productTableFields">
        <template #cell(URL)="data">
          <span>
            <a :href="data.value" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-primary">Open</a>
          </span>
        </template>
        <template #cell(images)="data">
          <span v-if="data.value.image" @click="showImage(data.value.image[0].url)" class="btn btn-sm btn-outline-light">Show</span>
          <span v-else>No image</span>
        </template>
        <template #cell(codename)="data">
          <span class="align-middle">
            <b-icon-dash @click="decrementToOrder(data.value)" class="pointer"></b-icon-dash>
            {{inlineQ[data.value] || 0}}
            <b-icon-plus @click="incrementToOrder(data.value)" class="pointer"></b-icon-plus>
            <button @click="orderArticle(data.value, inlineQ[data.value])" class="ml-2 btn btn-outline-light">
              <b-icon-download></b-icon-download>
            </button>
          </span>
        </template>
      </b-table>
    </b-row>
    <b-row v-else>
      <b-col class="mt-2 p-3 w-100 text-center bg-primary rounded">
        <h4>
          Parts will be invoiced to <strong class="text-uppercase">{{io ? user.username : 'Local Client'}}</strong>
        </h4>
      </b-col>
    </b-row>
  </b-container>
  <b-modal ref="image-modal" id="image-modal" hide-footer title="Product image">
    <div class="d-block text-center">
      <b-img :src="productImage" fluid alt="No image"></b-img>
    </div>
    <b-button class="mt-3" variant="outline-danger" block @click="$bvModal.hide('image-modal')">Close</b-button>
  </b-modal>

  <b-container v-if="activeForOrder.length" class="mt-3">
    <b-row>
      <b-table striped hover :items="activeForOrder" :fields="activeTableFields">
        <template #cell(product)="data">
          <span v-if="data.value">{{data.value.name}}</span>
          <span v-else>No name</span>
        </template>
        <template #cell(_id)="data">
          <button @click="removeArticle(data.value)" class="btn btn-light w-75">
            <b-icon-trash></b-icon-trash>
          </button>
        </template>
      </b-table>
    </b-row>
  </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '@/fixed';

export default {
  name: 'MerchantOrder',
  data: () => ({
    user: null,
    loading: false,
    inputType: 'oem',
    metaData: '',
    code: '',
    io: true,
    articles: [],
    productTableFields: [
      {
        key: 'name',
        label: 'Product name',
      },
      {
        key: 'URL',
        label: 'Link to BD webshop',
      },
      {
        key: 'images',
        label: 'Product image',
      },
      {
        key: 'codename',
        label: 'Order from supplier',
      },
    ],
    activeTableFields: [
      {
        key: 'sku',
        label: 'SKU',
      },
      {
        key: 'product',
        label: 'Name',
      },
      {
        key: 'count',
        label: 'Count',
      },
      {
        key: 'num',
        label: 'Number',
      },
      {
        key: 'metaData',
        label: 'Ordered for',
      },
      {
        key: '_id',
        label: 'remove',
      },
    ],
    productImage: '',
    inlineQ: {},
    activeForOrder: [],
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem('user'));
    await this.getActiveForMerchant();
  },
  methods: {
    async search() {
      if (!this.code) return;

      const url = `${fixed.API_URL}/merchant/${this.inputType}2article?${this.inputType}=${this.code}`;

      this.loading = true;
      try {
        const { data } = await axios.get(url, { withCredentials: true });
        if (!data) {
          this.$toast.info('No articles with that code');
        } else {
          this.articles = Array.isArray(data) ? data : [data];
          this.code = '';
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.error('you\'re not authorised for that action ✋🏻');
        } else {
          this.$toast.error(error?.response?.data || 'Can\'t fetch products');
        }
        this.articles = [];
      }
      this.loading = false;
    },
    showImage(url) {
      if (!url) return;

      this.productImage = url;
      this.$refs['image-modal'].show();
    },
    incrementToOrder(codename) {
      if (!this.inlineQ[codename]) {
        this.inlineQ[codename] = 0;
      }
      this.inlineQ[codename] += 1;
      this.inlineQ = { ...this.inlineQ };
    },
    decrementToOrder(codename) {
      if (!this.inlineQ[codename]) return;
      this.inlineQ[codename] -= 1;
    },
    async orderArticle(sku, qtt) {
      if (qtt < 1 || !sku || !this.metaData) {
        this.$toast.warning('ORDER FOR is required');
        return;
      }

      if (this.isRegos && !/^[0-9]+$/.test(this.metaData)) {
        this.$toast.error('regos ID has to be a number');
        return;
      }

      this.loading = true;
      try {
        const meta = this.metaData;
        const invoiceOrderer = this.io;

        await axios.post(`${fixed.API_URL}/merchant/merchant-order`, {
          sku,
          qtt,
          meta,
          invoiceOrderer,
        }, { withCredentials: true });
        await this.getActiveForMerchant();
        this.$toast.success('Article ordered successfully');
        this.inlineQ = {};
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    async removeArticle(id) {
      if (!id) return;
      this.loading = true;
      try {
        await axios.delete(`${fixed.API_URL}/merchant/merchant-order/${id}`, { withCredentials: true });
        this.$toast.success('Article removed successfully');
        await this.getActiveForMerchant();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    async getActiveForMerchant() {
      try {
        const { data } = await axios.get(`${fixed.API_URL}/merchant/merchant-active?user=${this.user.id}`, { withCredentials: true });
        if (!data || !data.length) {
          this.activeForOrder = [];
        } else {
          this.activeForOrder = data.sort((a, b) => {
            if (a.metaData.toLowerCase() < b.metaData.toLowerCase()) return -1;
            if (a.metaData.toLowerCase() > b.metaData.toLowerCase()) return 1;
            return 0;
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    toggleIo() {
      this.io = !this.io;
    },
  },
};
</script>

<style>

</style>
